import { useState, useEffect } from "react";
import getRecommendations from "../../api/mightLikeApi";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

const useRecommendationProducts = ({
  showUpSell,
  isInStock,
  isStockStateReady,
  isMixAndMatch,
}) => {
  const { features } = useRuntimeConstants();
  const [recommendationProducts, setRecommendationProducts] = useState([]);

  useEffect(() => {
    if (
      features?.peopleAlsoBoughtEnabled !== false &&
      isStockStateReady &&
      !isMixAndMatch &&
      showUpSell
    ) {
      getRecommendations({ isInStock, type: "complementary" })
        .then((products) => {
          setRecommendationProducts(products);
        })
        .catch(() => {});
    }
  }, [showUpSell, isInStock, isStockStateReady, isMixAndMatch, features]);

  return recommendationProducts;
};

export default useRecommendationProducts;
